import classNames from 'classnames';
import arrowRightPagination from 'src/global/assets/icons/arrow-right-pagination.svg';
import arrowLeftPagination from 'src/global/assets/icons/arrow-left-pagination.svg';
import Icon from 'src/components/Icon';
import { IPagination } from '@interfaces/services';

import { styles } from './styles';
import PaginationItem from './PaginationItem';

interface IComponentPagination {
  handlePagination: (selectPage: number) => void;
  paginationResult: IPagination;
  paginationNumberStart?: number;
}

const PaginationComponent = ({
  handlePagination,
  paginationResult,
  paginationNumberStart = 0
}: Readonly<IComponentPagination>) => {
  const { classes } = styles();
  const MAX_PAGES = 5;
  const { page, totalPages } = paginationResult;

  const currentPage: number = Number(page) + Number(paginationNumberStart);
  const pageNumbers: number[] = [];

  for (
    let i =
      paginationResult.totalPages > MAX_PAGES && paginationResult.page > MAX_PAGES - 2 ? currentPage - 2 : 1;
    pageNumbers.length < MAX_PAGES && i <= totalPages;
    i++
  ) {
    pageNumbers.push(i);
  }

  return (
    <div className={classes.paginationContainer}>
      <div className={classes.numberContainer}>
        <button
          type="button"
          data-testid="arrow-back"
          className={classNames(classes.arrowItem, {
            [classes.disable]: currentPage === 1
          })}
          disabled={currentPage === 1}
          aria-label="Página anterior"
          onClick={() => handlePagination(currentPage - 1 - paginationNumberStart)}>
          <Icon isDisabled={currentPage === 1} source={arrowLeftPagination} />
        </button>
        {pageNumbers.map((pageNumber) => (
          <div key={`page-${pageNumber}`}>
            <PaginationItem
              pageNumber={pageNumber}
              active={pageNumber === currentPage}
              handlePagination={(selectPage: number) => handlePagination(selectPage - paginationNumberStart)}
            />
          </div>
        ))}
        <button
          type="button"
          data-testid="arrow-next"
          className={classNames(classes.arrowItem, {
            [classes.disable]: currentPage === totalPages
          })}
          disabled={currentPage === totalPages}
          aria-label="Página siguiente"
          onClick={() => handlePagination(currentPage + 1 - paginationNumberStart)}>
          <Icon isDisabled={currentPage === totalPages} source={arrowRightPagination} />
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
